<template>
  <div>
    <div
      :class="[isShapeModalShown ? 'd-none':'' ]"
      class="shape-modal-wrapper position-fixed align-items-center justify-content-center d-flex position-fixed shape-modal">
      <div class="modal-inner align-items-center justify-content-center d-flex">
        <div class="bm-modal-content bg-white px-24 pt-24  pb-44 position-fixed rounded rounded-4 scroller w-100 h-100">
          <div
            class="p-0 border-0 text-end close-icon-wrapper custom-icon"
            @click="handleModalClose">
            <icon name="close-icon"/>
          </div>
          <div class="bm-modal-body border-0 mt-3">
            <h2 class="text-center modal-heading text-dark-gray fs-20 mb-0">Svg Library</h2>
            <div class="tabs-wrapper">
              <div class="main-tabs-content mt-20">
                <div class="images-thumbnail-wrapper ps-20 pe-12 scroller d-block mt-10">
                  <div class="thumbnail-inner d-flex flex-wrap">
                    <div
                      v-if="getSVGShapeCategories.length"
                      class="category-container d-flex w-100 mb-15"
                    >
                      <div
                        :class="[getSVGCategoryFilter == '' ? 'category-name selected':'category-name']"
                        @click="filterShapes('')"
                      >
                        All
                      </div>
                      <div
                        v-for="(category) in getSVGShapeCategories"
                        :key="'category-'+category.Id"
                        :class="[getSVGCategoryFilter == category.Id ? 'category-name selected':'category-name']"
                        @click="filterShapes(category.Id)"
                      ><img
                        :src="category.VirtualPath"
                        class="shape-category-icon">
                        <div/>
                        {{ category.Name }}
                      </div>
                    </div>
                    <div
                      v-if="isLoading"
                      class="d-flex w-100 justify-content-center mt-15">
                      <Spinner
                        :speed="1"
                        size="large"
                        font-size="11px"
                        message="Loading SVG Shapes..." />
                    </div>

                    <div
                      v-if="getSvgShapes.length < 1 && !isLoading"
                      class="d-flex justify-content-center w-100 mt-10"
                      style="font-size: 16px">
                      No Suitable Shapes in the Library
                    </div>
                    <div
                      v-for="(image, i) in getSvgShapes"
                      :class="[selectedShape.Title==image.Title ? 'border border-blue-primary border-2 image-selected':'']"
                      :key="i"
                      class="thumbnail-box mb-12 me-8 ms-8 position-relative rounded rounded-4"
                      @click.stop="selectingShape({VirtualPath:`${image.VirtualPath}`, Title:image.Title})">
                      <img :src="image.VirtualPath">
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="bm-modal-footer mt-48 d-flex justify-content-between align-items-center">
            <button
              v-if="0"
              class="lf-btn blue-border-btn action-btn bg-white"
              @click.stop="handleModalClose">Cancel</button>
            <button
              v-if="0"
              class="bm-primary-btn action-btn"
              @click.stop="addShape">Add</button>
          </div>
        </div>
      </div>
      <div
        :class="[isShapeModalShown?'d-none':'' ]"
        class="backdrop position-fixed h-100 w-100"
        @click="handleModalClose"/>
    </div>
  </div>
</template>

<script>
import ThumbnailBox from '@/components/ThumbnailBox/ThumbnailBox.vue';
import axios from 'axios';
import EventBus from '@/EventBus';
import _ from 'lodash';
import {
  fetchingSvg, convertingDifferentMeasurementUnitIntoPx,
} from '@/components/Helper';
import Spinner from 'vue-simple-spinner';

export default {
  name:       'ShapeModal',
  components: { 'thumbnail-box': ThumbnailBox, Spinner },
  data() {
    return {
      isShapeModalShown: false,
      selectedShapeData: {},
      svgShapes:         [],
      selectedShape:     { Title: '', VirtualPath: '' },
      isLoading:         false,
    };
  },
  computed: {
    getSVGShapeCategories() {
      return this.$store.getters.getSVGCategories;
    },
    getSvgShapes() {
      return this.$store.getters.getProductSvg;// this.svgShapes;
    },
    getSVGCategoryFilter() {
      return this.$store.getters.getSVGCategoryFilter;
    },
  },
  mounted() {
    // this.$store.commit('updateSVGCategories',[])
    // this.$store.commit('updataProductSvg',[])
    this.fetchSVGShape();
    this.filterShapes('');
  },
  methods: {
    async filterShapes(categoryId) {
      this.$store.commit('updataProductSvg', []);
      this.$store.commit('setSVGCategoryFilter', categoryId);
      const method     = (categoryId == '') ? 'GetSvgShapesByBank' : 'GetShapesByCategory';
      const parentNode = (categoryId == '') ? 'GetSvgShapesByBankResult' : 'GetShapesByCategoryResult';
      const domainUrl  = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url        = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=${method}&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/&categoryId=${categoryId}`;
      this.isLoading   = true;
      const parser     = new DOMParser();
      axios.get(url)
        .then((response) => {
          console.log(response);

          const xmlParsed   = parser.parseFromString(response.data, 'text/xml');
          let svgCollection = xmlParsed.getElementsByTagName(parentNode);
          svgCollection[0] && (svgCollection = svgCollection[0].innerHTML);
          const parse = JSON.parse(svgCollection);
          this.$store.commit('updataProductSvg', parse);
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          const temp = [{
            Id:           '1ff3ca30-2569-41c5-ab1e-006bc5c608c3',
            Title:        '42',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202206/Shapes_42.svg',
            CategoryName: 'Frames \u0026 Borders',
            CategoryId:   'a1b1acd8-8c1d-4c60-87f0-a25a321a3660',
          },
          {
            Id:           'c0d428b2-28cc-45e8-86f1-00c6bdf36cf7',
            Title:        '21',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202111/21.svg',
            CategoryName: 'Frames \u0026 Borders',
            CategoryId:   'a1b1acd8-8c1d-4c60-87f0-a25a321a3660',
          },
          {
            Id:           '67b4cd44-b9e9-4c43-afc3-022bf8725394',
            Title:        '31',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202205/MiscShapes-01.svg',
            CategoryName: 'Lines \u0026 Swooshes',
            CategoryId:   '0c3b1018-0f7f-4cb1-9f7d-d031c18160bf',
          },
          {
            Id:           'aa083791-fe08-4047-ac1f-03420d533955',
            Title:        '58',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202206/Shapes_58.svg',
            CategoryName: 'Bubbles',
            CategoryId:   'fbbcfcb4-4e7e-480c-84be-35d814e70270',
          },
          {
            Id:           '96f6bc05-98fc-4f6b-8e4f-052995791312',
            Title:        'LinkedIn',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202209/LinkedIn-0107.svg',
            CategoryName: 'Logos',
            CategoryId:   'eaabe57a-e7a5-4288-89b1-e6e7d7b72f14',
          },
          {
            Id:           '78094b85-2fbf-4e73-a83b-084a9e87f1ba',
            Title:        'TM Icon',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202210/Icons_TM.svg',
            CategoryName: 'Icons',
            CategoryId:   'eca9a7d3-233a-4987-bc48-cc81245c33ba',
          },
          {
            Id:           'ac7a6723-f873-4558-871d-12d9551be6bf',
            Title:        '39',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202206/Shapes_39.svg',
            CategoryName: 'Arrows',
            CategoryId:   'dfd8ef5c-a5a0-4de0-ad2b-39f27e0a23ed',
          },
          {
            Id:           'dbfcfaf4-3d44-45f7-95d7-149678ab7d77',
            Title:        '65',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202209/Hollow%20Square%20Icon-01.svg',
            CategoryName: 'Frames \u0026 Borders',
            CategoryId:   'a1b1acd8-8c1d-4c60-87f0-a25a321a3660',
          },
          {
            Id:           '75524fb4-68c7-415d-aff4-14c5d041de6d',
            Title:        'LinkedIn 2',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202212/LinkedIn-02.svg',
            CategoryName: 'Logos',
            CategoryId:   'eaabe57a-e7a5-4288-89b1-e6e7d7b72f14',
          }];

          this.$store.commit('updataProductSvg', temp);
          this.isLoading = false;
        });
    },

    handleModalClose() {
      this.$store.commit('setShapeModel', false);
      this.isShapeModalShown = !this.isShapeModalShown;
    },
    fetchSVGShape() {
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=SearchSvgShapeCategory&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        console.error('loading SVG categories', Response);
        const parser      = new DOMParser();
        const xmlParsed   = parser.parseFromString(Response.target.response, 'text/xml');
        let svgCollection = xmlParsed.getElementsByTagName('SearchSvgShapeCategoryResult');
        svgCollection[0] && (svgCollection = svgCollection[0].innerHTML);
        const parse = JSON.parse(svgCollection);
        this.$store.commit('updateSVGCategories', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.log('Error in loading Categories', e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    selectingShape(data) {
      this.selectedShape = _.cloneDeep(data);
      this.$nextTick(() => {});
      this.addShape();
    },

    async addShape(data) {
      if (!this.selectedShape.Title) {
        alert('Please select the shape');
        return;
      }
      const shapeInput = await fetchingSvg(this.selectedShape.VirtualPath);
      this.handleModalClose();
      const style        = `style="transform-origin: left top; transform: scale(${1}, ${1});"`;
      shapeInput.content = shapeInput.content.includes('style="transform-origin: left top 0px;"') ? shapeInput.content.replace('style="transform-origin: left top 0px;"', style) : shapeInput.content.replace('style="transform-origin: left top;"', style); // check for the browser compatibility
      // shapeInput.content = shapeInput.content.replace()
      EventBus.$emit('AddSvgShape', {
        content: shapeInput.content, name:    this.selectedShape.Title, color:   'rgb(0,0,0)', width:   convertingDifferentMeasurementUnitIntoPx(shapeInput.width), height:  convertingDifferentMeasurementUnitIntoPx(shapeInput.height),
      });
    },
  },
};

</script>

<style lang="scss" scoped>
    .shape-modal {
        .thumbnail-box {
            padding: 20px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
                box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
            }

        }
      .category-container{
        width: 100%; padding: 10px 5px; border: thin dashed #3bb0fa;
        flex-wrap: wrap;
        gap: 5px;
      }
      .category-name{
        padding: 0px 10px;
        border: solid thin #dee2e6;
        background: #FCFCFC;
        color: #3f3f3f;
        font-family: 'open sans';
        height: 44px;
        font-size: 14px;
        align-items: center;
        display: flex;
        border-radius: 3px;

        &.selected{
          color: #3bb0fa;
          border-color: #3bb0fa;

        }
        &:hover{
          &:not(.selected){
          box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
          background: #ffffff;
          border: 1px solid #ffffff !important;
          transition: none !important;
          cursor: pointer;
          }
        }
        .shape-category-icon{
          width: 24px;
          max-height: 24px;
          margin: 0px 5px;
        }
      }

        .thumbnail-box img {
            height: 100px !important;
            width: 100px !important;
            object-fit: fill !important
        }
        .image-selected{
            transition: none!important;
        &:hover{
            box-shadow: none !important;
            transform: none !important;
        }
        }
    }
    .shape-modal-wrapper {
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 4000;

        .bm-modal-content {
            max-height: 90vh;
            overflow-y: auto;
            max-width: 900px;
            height: fit-content !important;
            width: 70vw !important;
            box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
            z-index: 99;
        }
        .display-grid{
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
        }
        .action-btn {
            min-width: 100px;
        }

        .modal-heading {
            font-weight: 600;
            line-height: 32px;
        }


        .search-bar-wrapper {
            min-width: 432px;
            max-width: none !important;
        }

        .bm-input {
            /*width: 100%;*/
            box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.08);
        }


        .thumbnail-inner {

            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }

        .images-thumbnail-wrapper {
            max-height: 484px;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 8px;
                //margin-right: 4px;
                background-color: $grey10;
                border: 1px solid $grey20;
                border-radius: 4px;
            }

            &::-webkit-scrollbar-thumb {
                box-shadow: inset 0px 0px 5px #dddddd;
                border: none;
                border-right: 2.5px solid transparent;
                border-left: 2.5px solid transparent;
                background: transparent;
            }
        }

        .backdrop {
            background-color: rgba(237, 237, 237, 0.6);
            filter: blur(4px);
            top: 0;
            left: 0;
            z-index:0;
        }

        .search-icon {
            left: 14px;
            top: 11px;
        }

        .close-icon {
             right: 10px;
            top: 10px;
        }

        .browse-btn {
            min-width: 125px;
        }

        .select-file-computer {
            min-height: 412px;
            border-style: dashed !important;

            .file-upload-btn {
                input {
                    opacity: 0;
                    cursor: pointer;
                    left: 0;
                    top: 0;
                }
            }
        }

        .btn-close {
            height: 16px;
            width: 16px;
            outline: 0px;
            &:focus {
                outline: 0px;
            }
        }

        .bm-modal-footer {
            margin: 0 auto;
        }

        .focused {
            .bm-input{
                border-color:$blue50 !important;
                color: $grey80;
            }

            .close-icon{
                display: block !important;
            }

            .search-icon {
                svg{
                    path{
                        stroke: #3BB0FA;
                    }
                }
            }
        }

        .remove-focus {
            &.close-icon {
                display: block !important;
            }
        }

        .remove-focus{
            &.bm-input {
                border: 1px solid #EDEDED;
            }
        }

        .bm-input{
            &:focus + {
                .search-icon{
                    svg{
                        path{
                            stroke: #3BB0FA;
                        }
                    }
                }
            }
        }

        .active-search{
            .icon{
                svg{
                    path{
                        stroke: #3BB0FA;
                    }
                }
            }
        }

        .remove-focus{
            .icon{
                svg{
                    filter: none;
                }
            }
        }
    }

    .close-icon-wrapper {
        .icon {
            display: inline-flex !important;
            cursor: pointer;
        }
    }
    .thumbnail-box {
        flex-basis: calc(20% - 16px);
        transition: all 0.2s;

        &:hover{
            transform: scale(1.05);
        }
    }

    .thumbnail-inner {
        margin: 0px -8px;

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }

    .images-thumbnail-wrapper {
        max-height: 356px;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 8px;
            //margin-right: 4px;
            background-color: $grey10;
            border: 1px solid $grey20;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            box-shadow: inset 0px 0px 5px #dddddd;
            border: none;
            border-right: 2.5px solid transparent;
            border-left: 2.5px solid transparent;
            background: transparent;
        }
    }


    .btn-close {
        height: 16px;
        width: 16px;
        outline: 0px;

        &:focus {
            outline: 0px;
        }
    }

    .bm-modal-footer {
        margin: 0 auto;
    }

    .focused {
        .bm-input {
            border-color: $blue50 !important;
            color: $grey80;
        }

        .close-icon {
            display: block !important;
        }

        .search-icon {
            svg {
                path {
                    stroke: #3BB0FA;
                }
            }
        }
    }

    .remove-focus {
        &.close-icon {
            display: block !important;
        }
    }

    .remove-focus {
        &.bm-input {
            border: 1px solid #EDEDED;
        }
    }

    .bm-input {
        &:focus + {
            .search-icon {
                svg {
                    path {
                        stroke: #3BB0FA;
                    }
                }
            }
        }
    }

    .active-search {
        .icon {
            svg {
                path {
                    stroke: #3BB0FA;
                }
            }
        }
    }

    .remove-focus {
        .icon {
            svg {
                filter: none;
            }
        }
    }

    .close-icon-wrapper {
        .icon {
            display: inline-flex !important;
            cursor: pointer;
        }
    }

    .thumbnail-box {
        overflow: hidden;
        cursor:pointer;
        .image-selected{
            transition: none !important;
        }
        &:not(.image-selected) {
            &:hover {
                img {
                    transform: scale(1.1);
                    transition: all 0.3s;
                }

                .delete-icon{
                    opacity: 1 !important;
                    transition: all ease 0.3s;
                }
            }
        }
        &:hover{
            .delete-icon{

            }

        }
        img {
            transition: transform 0.3s;
            border-radius: 4px;

        }
        .delete-icon{
            height: 22px;
            width:22px;
            background:rgba(255, 255, 255, 0.9);
            transition: all ease-in-out 0.3s;
            right: 4px;
            top: 4px;
            opacity: 0;
            z-index: 2;
        }
    }

</style>
